const getControlNumberForMultiplier = (ssn: string, multiplier: number[]) => {
    let sum = 0;

    for (let i = 0; i < 10; i++) {
        sum += Number(ssn.charAt(i)) * multiplier[i];
    }

    return sum % 11;
};

const getControlNumber = (ssn: string) => {
    let control = getControlNumberForMultiplier(ssn, [1, 2, 3, 4, 5, 6, 7, 8, 9, 1]);
    if (control === 10) {
        control = getControlNumberForMultiplier(ssn, [3, 4, 5, 6, 7, 8, 9, 1, 2, 3]);
        if (control === 10) {
            return 0;
        }
    }

    return control;
};

export const validateSsn = (ssn: string) => {
    if (ssn?.length !== 11) {
        return false;
    }

    const control = getControlNumber(ssn);
    if (control !== parseInt(ssn.charAt(10))) {
        return false;
    }

    const birthDate = getBirthday(ssn);
    return new Date().getTime() > birthDate.getTime();
};

const getBirthday = (ssn: string) => {
    let year = Number(ssn.substring(1, 3));

    const month = Number(ssn.substring(3, 5));
    const day = Number(ssn.substring(5, 7));
    const firstNumber = Number(ssn.substring(0, 1));

    if (firstNumber === 1 || firstNumber === 2) {
        year += 1800;
    } else if (firstNumber === 3 || firstNumber === 4) {
        year += 1900;
    } else if (firstNumber === 5 || firstNumber === 6) {
        year += 2000;
    } else {
        year += 2100;
    }

    return new Date(year, month, day);
};
